import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    meta: { requiresAuth: false, title: "Login", show_back_btn: false },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/pages/login-page/Login.vue"),
  },
  // {
  //     path: '/',
  //     name: 'base',npm
  //     component: () => import( /* webpackChunkName: "WarehouseProfile" */ "@/components/layout/Base.vue"),
  // },
  {
    path: "/",
    name: "admin",
    component: () =>
      import(
        /* webpackChunkName: "WarehouseProfile" */ "@/components/layout/Base.vue"
      ),
    children: [
      {
        path: "customer",
        name: "customers",
        meta: { requiresAuth: true, title: "Customer", show_back_btn: false },
        component: () =>
          import(/* webpackChunkName: "customer" */ "@/pages/customer-pages/"),
      },
      {
        path: "customer/details/:id",
        name: "customer-details",
        meta: {
          requiresAuth: true,
          title: "Customer details",
          show_back_btn: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer" */ "@/pages/new-customer-pages/NewCustomerDetails"
          ),
        // component: () => import( /* webpackChunkName: "customer" */ "@/pages/customer-pages/CustomerDetails")
      },
      {
        path: "team/",
        name: "team",
        meta: {
          requiresAuth: true,
          title: "Team",
          show_back_btn: false,
        /* The filter bar owns search on this screen now, the way it does on
           every KarroFin module. Two search boxes on one page is one too many. */
        show_global_search: false,
        },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/team-pages/"),
      },
      {
        path: "emi-analysis/",
        name: "emi-analysis",
        meta: {
          requiresAuth: true,
          title: "EMI Analysis",
          show_back_btn: false,
        },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/emi-analysis/"),
      },
      {
        path: "payment/",
        name: "payment",
        meta: { requiresAuth: true, title: "Payment", show_back_btn: false },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/payments/"),
      },
      {
        path: "review/",
        name: "review",
        meta: { requiresAuth: true, title: "Review", show_back_btn: false },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/review/index"),
      },
      {
        path: "service_area/",
        name: "service_area",
        meta: {
          requiresAuth: true,
          title: "Service Area",
          show_back_btn: false,
        },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/service-area/index"),
      },
      {
        path: "session_history/",
        name: "session_history",
        meta: {
          requiresAuth: true,
          title: "Session History",
          show_back_btn: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "session" */ "@/pages/session-pages/index"
          ),
      },
      {
        path: "leads",
        name: "leads",
        // `title` stays "Leads" and is NOT the caption. The global
        // beforeRouteLeave in main.js tests it as a substring of the joined
        // permission list, and it passes today only because the granted
        // permission is "KarroFin Leads". "Leads Management" is a substring of
        // nothing in that list, so putting the new name here would bounce every
        // attempt to open the page. Navbar.vue renders `display_title || title`,
        // which is why the rename goes there instead.
        meta: {
          requiresAuth: true,
          title: "Leads",
          display_title: "Leads Management",
          show_back_btn: false,
          // The filter bar owns search on this screen now.
          show_global_search: false,
        },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/Leads/index"),
      },
      {
        path: "products",
        name: "products",
        meta: { requiresAuth: true, title: "Products", show_back_btn: false },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/Products/index"),
      },
      {
        path: "product/:id",
        name: "product",
        meta: { requiresAuth: true, title: "Product", show_back_btn: true },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/Products/productDetail"),
      },
      {
        path: "reports",
        name: "reports",
        meta: {
          requiresAuth: true,
          title: "Reports",
          show_back_btn: false,
        /* The filter bar owns search on this screen now, the way it does on
           every KarroFin module. Two search boxes on one page is one too many. */
        show_global_search: false,
        },
        component: () =>
          import(/* webpackChunkName: "team" */ "@/pages/reports/index"),
      },
      {
        path: "session/detail/:id",
        name: "session_details",
        meta: {
          requiresAuth: true,
          title: "Session Detail",
          show_back_btn: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "session detail" */ "@/pages/session-pages/session-detail"
          ),
      },
      // new tabs for new onboarding customer
      {
        path: "new-customer",
        name: "new-customers",
        meta: {
          requiresAuth: true,
          title: "New Customer",
          show_back_btn: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "new customer" */ "@/pages/new-customer-pages/"
          ),
      },
      {
        path: "new-customer/details/:id",
        name: "new-customer-details",
        meta: {
          requiresAuth: true,
          title: "Customer details",
          show_back_btn: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "new customer" */ "@/pages/new-customer-pages/NewCustomerDetails"
          ),
      },
      {
        path: "pre-verification",
        name: "pre-verification",
        meta: {
          requiresAuth: true,
          title: "Pre Verification",
          show_back_btn: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "new customer" */ "@/pages/pre-verification/"
          ),
      },
      {
        path: "pre-verification/details/:id",
        name: "pre-verification-details",
        meta: {
          requiresAuth: true,
          title: "Customer details",
          show_back_btn: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer" */ "@/pages/new-customer-pages/NewCustomerDetails"
          ),
        // component: () => import( /* webpackChunkName: "customer" */ "@/pages/customer-pages/CustomerDetails")
      },
      {
        path: "loan-applied",
        name: "loan-applied",
        meta: {
          requiresAuth: true,
          title: "Loan Applied",
          show_back_btn: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "new customer" */ "@/pages/loan-applied/"
          ),
      },
      {
        path: "loan-applied/details/:id",
        name: "loan-applied-details",
        meta: {
          requiresAuth: true,
          title: "Customer details",
          show_back_btn: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer" */ "@/pages/new-customer-pages/NewCustomerDetails"
          ),
        // component: () => import( /* webpackChunkName: "customer" */ "@/pages/customer-pages/CustomerDetails")
      },
      {
        path: "disbursement",
        name: "disbursement",
        meta: {
          requiresAuth: true,
          title: "Disbursement",
          show_back_btn: false,
        /* The filter bar owns search on this screen now, the way it does on
           every KarroFin module. Two search boxes on one page is one too many. */
        show_global_search: false,
        },
        component: () => {
          return import(
            /* webpackChunkName: "new-customer" */ "@/pages/disbursement/index.vue"
          );
        }
      },
      {
        path: "disbursement/details/:id",
        name: "disbursement-details",
        meta: {
          requiresAuth: true,
          title: "Customer details",
          show_back_btn: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer" */ "@/pages/new-customer-pages/NewCustomerDetails"
          ),
        // component: () => import( /* webpackChunkName: "customer" */ "@/pages/customer-pages/CustomerDetails")
      },
      {
        path: "business-loan",
        name: "business-loan",
        meta: {
          requiresAuth: true,
          title: "Business Loan",
          show_back_btn: false,
        },
        component: () =>
          import(
            // /* webpackChunkName: "new customer" */ "@/pages/business-loan/"
            /* webpackChunkName: "new customer" */ "@/pages/business-loan/List.vue"
          ),
      },
      {
        path: "business-loan/details/:id",
        name: "business-loan-details",
        meta: {
          requiresAuth: true,
          title: "Business Loan details",
          show_back_btn: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer" */ "@/pages/business-loan/BusinessLoanDetails"
          ),
        // component: () => import( /* webpackChunkName: "customer" */ "@/pages/customer-pages/CustomerDetails")
      },
      {
        path: "loan-against-securities",
        name: "loan-against-securities",
        meta: {
          requiresAuth: true,
          title: "LAS",
          show_back_btn: false,
        },
        component: () =>
          import(/* webpackChunkName: "new customer" */ "@/pages/las"),
      },
      {
        path: "insurance",
        name: "insurance",
        meta: {
          requiresAuth: true,
          title: "Insurance",
          show_back_btn: false,
        /* The filter bar owns search on this screen now, the way it does on
           every KarroFin module. Two search boxes on one page is one too many. */
        show_global_search: false,
        },
        component: () =>
          import(/* webpackChunkName: "new-customer" */ "@/pages/insurance"),
      },
      // Credit Card was retired as a product; its two routes and the
      // pages/credit-card folder were removed. Nothing linked to them -- the
      // only push to credit-card-details had already been commented out.
      {
        path: "notification-panel",
        name: "notification-panel",
        meta: {
          requiresAuth: true,
          title: "Notification Panel",
          show_back_btn: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "new customer" */ "@/pages/notifications"
          ),
      },
      {
        path: "pl-funnel",
        name: "pl-funnel",
        meta: {
          requiresAuth: true,
          title: "PL Funnel",
          show_back_btn: false,
        },
        component: () =>
          import(/* webpackChunkName: "new customer" */ "@/pages/pl-funnel"),
      },

      /* ------------------------------------------------------------------
       * NEW KARROFIN ADMIN — additive block, safe to remove as a unit.
       *
       * Nothing above this comment is modified. All new code lives under
       * @/pages/karrofin, @/components/karrofin and @/app-js/karrofin.
       *
       * meta.title must be a substring of the joined permission_list: the
       * global beforeRouteLeave mixin in src/main.js blocks navigation
       * otherwise. The matching TabPermission rows are created server-side by
       * `manage.py seed_karrofin_permissions`.
       * ------------------------------------------------------------------ */
      {
        path: "karrofin",
        component: () =>
          import(
            /* webpackChunkName: "karrofin" */ "@/pages/karrofin/KarroFinLayout.vue"
          ),
        children: [
          {
            path: "",
            redirect: { name: "karrofin-dashboard" },
          },
          {
            path: "dashboard",
            name: "karrofin-dashboard",
            meta: {
              requiresAuth: true,
              title: "KarroFin Dashboard",
              display_title: "Dashboard",
              show_back_btn: false,
              // KarroFin screens carry their own FilterBar search and never
              // read the navbar's store value, so the navbar box would be a
              // control that does nothing. Opt out rather than opt in: the 21
              // legacy pages that do consume it stay untouched.
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/dashboard/index.vue"
              ),
          },
          {
            path: "users",
            name: "karrofin-users",
            meta: {
              requiresAuth: true,
              // Matches the sidebar entry: an already-granted permission, so
              // the route is reachable without a fresh login. See drawer.js.
              title: "KarroFin Leads",
              display_title: "User Management",
              show_back_btn: false,
              // This screen owns its own search box inside the FilterBar, so
              // the navbar one would be a second control for one query.
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/users/index.vue"
              ),
          },
          {
            path: "leads/:id",
            name: "karrofin-lead-detail",
            // show_back_btn stays false: the KarroFin page header renders its
            // own labelled back control, and the navbar's would duplicate it.
            meta: {
              requiresAuth: true,
              // The permission title stays "KarroFin Leads" -- it is the
              // granted string. Only the label the user reads changes.
              //
              // NOTHING links here any more, so the route is reachable only by
              // typing the URL. The Dashboard's "Recent offer clicks" table was
              // the last way in, and its @row-click was removed because that
              // table is live while getLeadDetail is still on mock data -- real
              // user_ids have no mock record, so every tap showed "Could not
              // load this". Give this screen a live endpoint before linking to
              // it again. User Management does NOT link here either: it used to
              // end each row with an icon opening the legacy
              // new-customer-details page, and that was removed deliberately --
              // the list carries the detail itself now.
              title: "KarroFin Leads",
              display_title: "Lead",
              show_back_btn: false,
              // KarroFin screens carry their own FilterBar search and never
              // read the navbar's store value, so the navbar box would be a
              // control that does nothing. Opt out rather than opt in: the 21
              // legacy pages that do consume it stay untouched.
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/leads/LeadDetail.vue"
              ),
          },
          {
            path: "offers",
            name: "karrofin-offers",
            meta: {
              requiresAuth: true,
              title: "KarroFin Offers",
              display_title: "Products",
              show_back_btn: false,
              // The screen owns a search box in its own FilterBar now, so the
              // navbar's would be a second control for one query.
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/offers/index.vue"
              ),
          },
          {
            path: "offers/:id",
            name: "karrofin-offer-detail",
            meta: {
              requiresAuth: true,
              title: "KarroFin Offers",
              display_title: "Products",
              show_back_btn: false,
              // KarroFin screens carry their own FilterBar search and never
              // read the navbar's store value, so the navbar box would be a
              // control that does nothing. Opt out rather than opt in: the 21
              // legacy pages that do consume it stay untouched.
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/offers/OfferDetail.vue"
              ),
          },
          {
            path: "applications",
            name: "karrofin-applications",
            meta: {
              requiresAuth: true,
              title: "KarroFin Applications",
              display_title: "Offer Management",
              show_back_btn: false,
              // This screen owns its own search inside the FilterBar, next to
              // Date range and City, so the navbar box would be a second
              // control for one query.
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/applications/index.vue"
              ),
          },
          {
            path: "notifications",
            name: "karrofin-notifications",
            meta: {
              requiresAuth: true,
              title: "KarroFin Notifications",
              display_title: "Notifications",
              show_back_btn: false,
              // KarroFin screens carry their own FilterBar search and never
              // read the navbar's store value, so the navbar box would be a
              // control that does nothing. Opt out rather than opt in: the 21
              // legacy pages that do consume it stay untouched.
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/notifications/index.vue"
              ),
          },
          {
            path: "campaigns",
            name: "karrofin-campaigns",
            meta: {
              requiresAuth: true,
              // This IS the permission string, not a caption -- the
              // beforeRouteLeave mixin in main.js substring-matches it against
              // the joined permission_list. The matching TabPermission row is
              // created by `manage.py seed_karrofin_permissions`.
              title: "KarroFin Campaigns",
              display_title: "Campaign URL",
              show_back_btn: false,
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/campaigns/index.vue"
              ),
          },
          {
            path: "templates",
            name: "karrofin-templates",
            meta: {
              requiresAuth: true,
              // The permission string, not a caption -- the beforeRouteLeave
              // mixin in main.js substring-matches it against the joined
              // permission_list. Seeded by `manage.py seed_karrofin_permissions`,
              // together with "KarroFin Templates Edit", which the page reads
              // separately to decide whether to show the write actions.
              title: "KarroFin Templates",
              display_title: "Template Library",
              show_back_btn: false,
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/templates/index.vue"
              ),
          },
          {
            // The old Automation page (a mock-fed view of the day-by-day
            // journey) was removed with the journey on 13 Oct 2026. Old links
            // land on the Notification History.
            path: "automation",
            name: "karrofin-automation",
            redirect: { name: "karrofin-automation-history" },
          },
          {
            path: "automation/history",
            name: "karrofin-automation-history",
            meta: {
              requiresAuth: true,
              // The permission string, not just a label (see the main.js
              // route mixin): kept from the old Automation screen, so whoever
              // could open that can open this, with no new row to seed.
              title: "KarroFin Automation",
              display_title: "Notification History",
              show_back_btn: false,
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/automation/History.vue"
              ),
          },
          {
            // The growth agent's day: who gets which message, and why. An old
            // ?tab= link (the removed Status moves / Performance tabs) opens it.
            path: "automation/agent",
            name: "karrofin-agent-tracker",
            meta: {
              requiresAuth: true,
              // Same permission string as the Notification History: whoever can
              // read what the agent sent can read what it decided.
              title: "KarroFin Automation",
              display_title: "Agent Tracker",
              show_back_btn: false,
              show_global_search: false,
            },
            component: () =>
              import(
                /* webpackChunkName: "karrofin" */ "@/pages/karrofin/agent/Tracker.vue"
              ),
          },
        ],
      },
      /* ------------------------- end KarroFin admin --------------------- */
    ],
  },
  {
    path: "/view-image/:document?/:image?",
    name: "view-image",
    meta: { requiresAuth: true, title: "Customer", show_back_btn: false },
    component: () =>
      import(
        /* webpackChunkName: "view image" */ "@/components/common/ViewImage"
      ),
  },
  {
    path: "/complete-cibil-report/:id",
    name: "compelete-cibil-report",
    meta: { requiresAuth: true, title: "CIBIL Report", show_back_btn: false },
    component: () =>
      import(
        /* webpackChunkName: "CIBIL Report" */ "@/components/new-customer/CompleteCibilDetails"
      ),
  },
  {
    path: "/complete-finvu-details/:finvu_doc_id",
    name: "compelete-finvu-details",
    meta: {
      requiresAuth: true,
      title: "Finvu Complete Details",
      show_back_btn: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "CIBIL Report" */ "@/components/new-customer/CompleteFinvuDetails"
      ),
  },
  // {
  //     path:'/logoutuser',
  //     name:'delete-account',
  //     meta: {requiresAuth: false, title: "Delete Account", show_back_btn: false},
  //     component:()=>import (/* webpackChunkName: "view image" */"@/pages/temporary-pages/DeleteAccount.vue")
  // },
  // {
  //     path:'/signRequest',
  //     name:'upload-signature',
  //     meta: {requiresAuth: false, title: "Upload Signature", show_back_btn: false},
  //     component:()=>import (/* webpackChunkName: "view image" */"@/pages/temporary-pages/UploadSignature.vue")
  // },

  // Anything unmatched lands on the dashboard instead of a blank screen. This
  // matters now that /credit-card is gone: a bookmark to a deleted page used to
  // render nothing at all, with no way back. Must stay last.
  {
    path: "*",
    redirect: { name: "karrofin-dashboard" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/* redirecting to home page if access token is not provided*/
router.beforeEach((to, from, next) => {
  let access_token = sessionStorage.getItem("token");
  if (to.meta.requiresAuth == true && !access_token) {
    next({
      name: "login",
    });
  } else if (to.meta.requiresAuth == false && access_token) {
    // The KarroFin dashboard is the landing screen: "New Customer" is no
    // longer in the sidebar, so dropping a signed-in user there would leave
    // them on a page they cannot navigate back from.
    next({
      name: "karrofin-dashboard",
    });
  } else next();
});

/*
 * Has the user navigated inside the app yet this session?
 *
 * A back control that pops history is the right behaviour -- it returns you to
 * the screen you actually came from, and it restores that screen's filters,
 * which pushing a fixed parent route cannot do. But a hard refresh or a pasted
 * deep link starts with nothing to pop back to, and popping there would throw
 * the user out of the app entirely. So callers ask this first and fall back to
 * a declared parent route when it is false.
 *
 * Counted here rather than read from window.history.length, which also counts
 * everything the user did before arriving at this site.
 */
let in_app_navigations = 0;
router.afterEach(() => {
  in_app_navigations += 1;
});

export function hasAppHistory() {
  // The first afterEach fires for the landing route itself, which is not
  // somewhere to go "back" to.
  return in_app_navigations > 1;
}

export default router;
